import { MatchesDashboard } from './MatchesDashboard'

export function SessionMarketPage() {
  return <MatchesDashboard />
}
